import React from 'react';
import { TAPTermsAndConditionsUsuarios } from '../../components';

const TermsAndConditionsUsuarios = () => {
  return (
    <>
    <TAPTermsAndConditionsUsuarios />
    </>
  )
}

export default TermsAndConditionsUsuarios
